// Общий разбор поисковой строки для всех списков панели.
//
// Раньше поиск жил только в нарядах (filterOrders), и правила были зашиты внутри него.
// Здесь то же поведение, но переиспользуемое: текст ищется без учёта регистра, а числа
// дополнительно сравниваются по цифрам — чтобы «10642» находило наряд №10642, а телефон
// искался независимо от того, как он записан: «8 (953) 823-99-77» или «79538239977».

export interface SearchQuery {
  text: string;
  /** Варианты цифр запроса: как введено и без ведущей 8/7 (её пишут по-разному) */
  digitVariants: string[];
  hasDigits: boolean;
}

/** Номер и без кода страны: 8XXXXXXXXXX и 7XXXXXXXXXX — это один и тот же телефон */
function digitVariants(digits: string): string[] {
  if (digits.length >= 4 && (digits.startsWith('8') || digits.startsWith('7'))) {
    return [digits, digits.slice(1)];
  }
  return [digits];
}

export function parseQuery(search: string): SearchQuery | null {
  const text = search.trim().toLowerCase();
  if (!text) return null;
  const digits = text.replace(/\D/g, '');
  return {
    text,
    digitVariants: digitVariants(digits),
    // Сравнение по цифрам включается от трёх цифр: по запросу «1» иначе находилось бы
    // почти всё, где вообще есть единица
    hasDigits: digits.length >= 3,
  };
}

export function matches(query: SearchQuery, fields: (string | number | null | undefined)[]): boolean {
  for (const field of fields) {
    if (field === null || field === undefined) continue;
    const value = String(field).toLowerCase();
    if (value.includes(query.text)) return true;
    if (!query.hasDigits) continue;
    const valueDigits = value.replace(/\D/g, '');
    if (!valueDigits) continue;
    for (const variant of digitVariants(valueDigits)) {
      for (const wanted of query.digitVariants) {
        if (variant.includes(wanted)) return true;
      }
    }
  }
  return false;
}

/** Фильтр списка по строке поиска: пустой запрос ничего не отсекает */
export function filterBySearch<T>(
  items: T[],
  search: string,
  fields: (item: T) => (string | number | null | undefined)[],
): T[] {
  const query = parseQuery(search);
  if (!query) return items;
  return items.filter((item) => matches(query, fields(item)));
}
